const colors = {
  blue: '#5a86e8',
  green: '#5ea763',
  yellow: '#f0c045',
  red: '#d45649',
  purple: '#6f42c1',
  orange: '#fd7e14',
  cyan: '#17a2b8',
  dark: '#343d48',
  headings: '#231f20',
  grey: '#6c757d',
  extraLight: '#fefefe',
  light: '#f1f1f1',
  disabled: '#adb5bd',
  lightBlue: '#93aff0',
  lightGreen: '#80b984',
  lightYellow: '#f5d37e',
  lightRed: '#df8177',
  analogBlue: '#5acde8',
  analogGreen: '#7da75e',
  analogYellow: '##cbf045',
  analogRed: '#d49c49'
};

export default colors;
